<img loading="lazy" class="img-preview" [src]="croppedImage.fImage" id="fImagePre" [hidden]="!croppedImage.fImage" data-gumlet="false">
<span *ngIf="media.fImage.name">{{media.fImage.name}}</span>
<div class="main-image-upload-area">
  <div class="image-input">
    <div class="title-container">
        <label class="image-label" for="fImage">
          {{info.fundraiser_image.placeholder}}
          <span class="optional-text">{{info.fundraiser_image.optional}} </span>
        </label>
        <!-- <app-popover [info]="info.fundraiser_image.popover"></app-popover> -->
      </div>
      <div>
        <input #fImage type="file" name="fImage" id="fImage" accept="image/*" (change)="fileChangeEvent($event, 'fImage')" style="display: none">
        <button mat-stroked-button type="button" (click)="openDialog(optionsDialog)" >
          {{info.fundraiser_image.upload}}
        </button>
      </div>
  </div>  <span class="popoverclass">
    <mat-icon aria-hidden="false" aria-label="View sample images" class="style-as-link" (click)="showPopoverUpload = true">help</mat-icon>
    <app-popover-loader *ngIf="showPopoverUpload" [show]="showPopoverUpload" [config]="{popupClass: 'input-popover', title: info?.cover_image.title, desc: info?.cover_image.desc, eg: info?.cover_image.see_egs, class: 'v2', emitneed: true}" (callemit)="openSampleImages($event)" (hideel)="showPopoverUpload = $event"></app-popover-loader>
  </span>
</div>

<div class="flex-conatiner" *ngIf="isSubmit">
  <span class="error-message">* Please upload required files</span>
</div>


<!-- Image modal -->
<ng-template #imageDialogTemplate>
  <section class="upload-info">
    <span class="info-txt">This is the image that will feature right on top of your page. Make it impactfull!</span>
    <span class="info-txt">Filetype: PNG, JPG, BMP</span>
    <span>Recommended Size: 700x400</span>
  </section>
  <mat-dialog-content #cropperDialogContent class="flex-container cropper-content mt-30" >
    <div *ngIf="!fileError?.error" class="crp-contanier">
      <angular-cropper #cropper [cropperOptions]="options" [imageUrl]="imgSrc"></angular-cropper>
    </div>
    <div *ngIf="!fileError?.error" class="drag-text">
      <mat-icon>zoom_out_map</mat-icon> Drag to Reposition
    </div>
    <div *ngIf="fileError?.error" class="error-display">
      <mat-icon class="icon-info"></mat-icon>
      <p class="text-center"><small><em>{{fileError?.message}}</em></small></p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions cdkFocusRegionstart>
    <div *ngIf="!fileError?.error" class="flex-container full-width">
      <div>
        <button mat-icon-button (click)="zoom('0.1')" ><mat-icon class="icon-plus control-icon"></mat-icon></button>
        <button mat-icon-button (click)="zoom('-0.1')"><mat-icon class="icon-minus control-icon"></mat-icon></button>
      </div>
      <div>
        <button mat-button color="primary" (click)="closeDialog()">CANCEL</button>
        <button mat-raised-button class="save-btn" color="primary" [disabled]="isSpin" (click)="save()">Save</button>
      </div>
    </div>
    <div *ngIf="fileError?.error" class="flex-container1">
      <button mat-raised-button class="choose-btn" type="button" (click)="openFile('fImage')" >CHOOSE ANOTHER IMAGE</button>
    </div>
  </mat-dialog-actions>
</ng-template>

<!-- image/video upload oprions dialog -->
<ng-template #optionsDialog>
  <div class="dialog-container">
    <div class="dialog-header option-header">
      <button (click)="dialog.closeAll()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content class="upload-options" cdkFocusRegionstart>
      <div class="options">
        <button class="option-btn" mat-button (click)="openFile('fImage')">
          <mat-icon class="icon-image op-icon" matPrefix>&nbsp;</mat-icon> Choose image from Gallery
        </button>
        <div class="line"></div>
        <!-- <button class="option-btn" mat-button (click)="selectFromFacebook()">
          <mat-icon class="icon-fb op-icon" matPrefix>&nbsp;</mat-icon> Choose from Facebook
        </button>
        <div class="line"></div> -->
        <button class="option-btn" mat-button (click)="openDialog(videoUrlDialog)">
          <mat-icon class="icon-video op-icon" matPrefix>&nbsp;</mat-icon> Enter Video Url
        </button>
      </div>
    </mat-dialog-content>
  </div>
</ng-template>

<ng-template #videoUrlDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <button (click)="dialog.closeAll()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content>
      <mat-form-field [color]="isVideoUrl?'warn':'primary'" class="input-container">
        <input matInput placeholder="Enter Video URL" [(ngModel)]="videoUrl" >
      </mat-form-field>
      <small class="error-message" *ngIf="isVideoUrl">Please enter a valid Youtube url!</small>
    </mat-dialog-content>
    <mat-dialog-actions class="flex-container1">
      <button mat-button color="primary" (click)="closeDialog()">CANCEL</button>
      <button mat-raised-button class="save-btn" color="primary" (click)="saveVideoURL()">Save</button>
    </mat-dialog-actions>
  </div>
</ng-template>

